import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "./i18n/I18nContext";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Stats } from "./components/Stats";
import { ChiSiamo } from "./components/ChiSiamo";
import { Catalogo } from "./components/Catalogo";
import { PdfDownload } from "./components/PdfDownload";
import { Contatti } from "./components/Contatti";
import { Footer } from "./components/Footer";

const Home = () => (
  <main data-testid="home-page" className="bg-white text-[#1a3a2a]">
    <Navbar />
    <Hero />
    <Stats />
    <ChiSiamo />
    <PdfDownload />
    <Catalogo />
    <Contatti />
    <Footer />
  </main>
);

function App() {
  return (
    <I18nProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </div>
    </I18nProvider>
  );
}

export default App;
